import { render, staticRenderFns } from "./NeQuarantine.vue?vue&type=template&id=60e40d3c&scoped=true"
import script from "./NeQuarantine.vue?vue&type=script&lang=js"
export * from "./NeQuarantine.vue?vue&type=script&lang=js"
import style0 from "./NeQuarantine.vue?vue&type=style&index=0&id=60e40d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e40d3c",
  null
  
)

export default component.exports